const SET_ENRICHMENT_LOGS_ACCOUNT_FILTERS = 'SET_ENRICHMENT_LOGS_ACCOUNT_FILTERS';
export interface IEnrichmentLogsAccountFilters {
  [key: string]: any;
}

interface Action {
  type: string;
  payload: IEnrichmentLogsAccountFilters;
}

export const setEnrichmentLogsAccountFilters = (filters: IEnrichmentLogsAccountFilters) => ({
  type: SET_ENRICHMENT_LOGS_ACCOUNT_FILTERS,
  payload: filters,
});

const initialState: IEnrichmentLogsAccountFilters = {};

export const enrichmentLogsAccountFiltersReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ENRICHMENT_LOGS_ACCOUNT_FILTERS:
      return { ...action.payload };
    default:
      return state;
  }
}